import React, { useEffect, useRef, useState } from 'react';

const Pips = ({ total, used, locked }) => (
  <div className="mt-1.5 flex gap-1" data-testid="oil-ops-counter-pips">
    {Array.from({ length: total }).map((_, i) => (
      <span key={i}
        className={`h-1.5 flex-1 rounded-full ${i < used ? (locked ? 'bg-red-900/70' : 'bg-zinc-700') : 'bg-amber-400'}`}
        style={i < used ? undefined : { boxShadow: '0 0 6px rgba(251,191,36,0.5)' }} />
    ))}
  </div>
);

const Card = ({ locked, title, value, testid, valueTestid, children }) => (
  <div className={`w-full shrink-0 rounded-xl border px-3 py-2 ${locked
    ? 'border-red-800/80 bg-gradient-to-r from-[#2a0a0a] to-[#150505]'
    : 'border-amber-900/70 bg-gradient-to-r from-[#1a1206] to-[#0b0906]'}`} data-testid={testid}>
    <div className="flex items-center justify-between gap-2">
      <p className={`text-[10px] font-black uppercase tracking-[0.14em] ${locked ? 'text-red-300' : 'text-amber-300'}`}>{title}</p>
      <p data-testid={valueTestid}
        className={`text-[11px] font-black tabular-nums ${locked ? 'text-red-200' : 'text-amber-200'}`}>{value}</p>
    </div>
    {children}
  </div>
);

export const OilLimitsCarousel = ({ opsUsed, opsMax, opsLocked, respectUsed, respectMax, respectLocked, resetIn }) => {
  const [idx, setIdx] = useState(0);
  const [auto, setAuto] = useState(true);
  const startX = useRef(null);

  useEffect(() => {
    if (!auto) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % 2), 5000);
    return () => clearInterval(t);
  }, [auto]);

  const swipe = (dir) => { setAuto(false); setIdx((i) => Math.max(0, Math.min(1, i + dir))); };

  return (
    <div className="mt-1" data-testid="oil-limits-carousel">
      <div className="overflow-hidden"
        onTouchStart={(e) => { startX.current = e.touches[0].clientX; }}
        onTouchEnd={(e) => {
          if (startX.current === null) return;
          const dx = e.changedTouches[0].clientX - startX.current;
          if (Math.abs(dx) > 40) swipe(dx < 0 ? 1 : -1);
          startX.current = null;
        }}>
        <div className="flex items-start transition-transform duration-500 ease-out"
          style={{ transform: `translateX(-${idx * 100}%)` }}>
          <Card testid="oil-ops-counter" locked={opsLocked} valueTestid="oil-ops-counter-value"
            title={opsLocked ? 'Limite atingido' : 'Operações de hoje'}
            value={opsLocked ? `LIBERA EM ${resetIn}` : `${opsUsed}/${opsMax}`}>
            <Pips total={opsMax} used={opsUsed} locked={opsLocked} />
            {opsLocked && (
              <p className="mt-1.5 text-[9px] font-bold uppercase leading-tight text-zinc-400" data-testid="oil-ops-counter-note">
                Espionagem Industrial não é operação ofensiva e continua liberada.
              </p>
            )}
          </Card>

          <Card testid="oil-respect-counter" locked={respectLocked} valueTestid="oil-respect-counter-value"
            title={respectLocked ? 'Teto de respeito atingido' : 'Respeito de hoje'}
            value={respectLocked ? `LIBERA EM ${resetIn}` : `${respectUsed}/${respectMax}`}>
            <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-zinc-800">
              <div className="h-full rounded-full transition-all duration-700"
                style={{
                  width: `${Math.min(100, (respectUsed / respectMax) * 100)}%`,
                  background: respectLocked ? 'linear-gradient(90deg,#7f1d1d,#ef4444)' : 'linear-gradient(90deg,#9f1239,#fb7185)',
                }} />
            </div>
            <p className="mt-1.5 text-[9px] font-bold leading-tight text-zinc-400" data-testid="oil-respect-counter-note">
              {respectLocked
                ? 'Nenhum serviço rende Respeito até a virada do dia. Espionagem hoje só serve pra informação, não sobe mais no ranking dos Procurados.'
                : 'Teto diário de Respeito por jogador. Passando dele, os serviços continuam funcionando, mas não rendem mais Respeito hoje.'}
            </p>
          </Card>
        </div>
      </div>
      <div className="mt-1.5 flex justify-center gap-1.5">
        {[0, 1].map((i) => (
          <button key={i} data-testid={`oil-limits-dot-${i}`} aria-label={`Cartão ${i + 1}`}
            onClick={() => { setAuto(false); setIdx(i); }}
            className={`h-1.5 rounded-full transition-all ${i === idx ? 'w-5 bg-amber-400' : 'w-1.5 bg-zinc-700'}`} />
        ))}
      </div>
    </div>
  );
};

export default OilLimitsCarousel;
